import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

/** An empty page with nothing to upload: an icon, a line, and the action that starts one if there is one. */
export function GeneratedBlankState({
  icon: Icon,
  action,
  children,
}: {
  icon: LucideIcon
  action?: ReactNode
  children?: ReactNode
}) {
  return (
    <div className="mt-10 mb-10 flex w-full flex-col items-center justify-center gap-5">
      <Icon className="text-ink-300 size-5" />
      {children && <p className="text-md text-ink-400 max-w-md text-center font-medium">{children}</p>}
      {action}
    </div>
  )
}
